var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "410C7AD2-9B66-4B15-B9BE-9067FFEDF7FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat_security-Copy",
    transform: "translate(-327.000000, -256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list/sidebar_security",
    transform: "translate(15.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-5-",
    transform: "translate(10.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warning-Alert",
    transform: "translate(301.500000, 35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_close",
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    fill: "#FFB606"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 10,
    cy: 10,
    r: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.04268616,12.5521029 C8.60620728,12.9675031 7.8995272,12.9675031 7.46304833,12.5521029 C7.46304833,12.5521029 7.45078434,12.5352579 7.43984502,12.5250011 C6.97007102,12.0130145 7.15088937,11.3574227 7.57588196,10.9471509 C8.01181386,10.5317506 14.1842843,4.77918886 14.1842843,4.77918886 C14.6202162,4.36378862 15.204809,4.43455868 15.6412878,4.84995892 C16.0772197,5.26535915 16.0772197,5.94230769 15.6412878,6.36283632 C15.6412878,6.36283632 9.18927304,12.4085078 9.04268616,12.5521029 Z M6.16778268,13.5776396 L6.30418235,13.7239103 C6.68083965,14.1278258 6.65874251,14.7606051 6.25482701,15.1372624 L6.10855627,15.273662 C5.70464077,15.6503193 5.0718615,15.6282222 4.69520421,15.2243067 L4.55880454,15.0780359 C4.18214724,14.6741204 4.20424438,14.0413412 4.60815988,13.6646839 L4.75443062,13.5282842 C5.15834612,13.1516269 5.79112539,13.1737241 6.16778268,13.5776396 Z",
    id: "Fill-34",
    fill: "#FFFFFF",
    transform: "translate(10.129196, 10.021543) rotate(-47.000000) translate(-10.129196, -10.021543) "
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.12c8eeb467b59af33028e08c38acafef.svg";
export { ForwardRef as ReactComponent };